////jc
import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
  Spinner,
  Button,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios, { AxiosError } from "axios";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { baseUrl, uploadFile, mediaUrl } from "../../../Utils/FileUpload";
import {
  Submit,
  EditVehicleModelTitle,
  VehicleModelTitle,
  Add,
} from "../../../Utils/Constants";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { VehicleModel } from "../../../Types/Tables.type";
import DataTable from "react-data-table-component";
import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
import { useNavigate, useLocation } from "react-router-dom";
import useCustomToasts from "../../../hooks/useCustomToast";
import Select from "react-select";

interface FormValues {
  model_name: string;
  brand_id: string;
  image: FileList;
  transmission: string;
  year: string;
}
interface ErrorResponse {
  message: string;
}
export default function EditVehicleModel() {
  const navigate = useNavigate();
  const { SuccessToast, ErrorToast } = useCustomToasts(navigate);
  const [loading, setLoading] = useState(true);
  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      model_name: "",
      brand_id: "",
      image: undefined,
    },
  });
  const [brands, setBrands] = useState<{ id: number; brand_name: string }[]>(
    []
  );
  const token = localStorage.getItem("token");
  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState<VehicleModel[]>([]);
  const [refresh, setRefresh] = useState(0);
  const [disabledDelete, setDisabledDelete] = useState<string | null>(null);
  const [disableAllDelete, setDisableAllDelete] = useState(false);
  const [disabledEnable, setDisabledEnable] = useState<string | null>(null);
  const [disableAllEnable, setDisableAllEnable] = useState(false);
  const [existingFile, setExistingFile] = useState<string>("");
  const location = useLocation();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}vehicle_model/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data: VehicleModel[] = response.data;
        // console.log(response.data)
        // setFilteredItems(
        //   data
        //     .filter((brand) => brand.is_deleted === 0)
        //     .sort((a, b) => b.is_active - a.is_active) // 👈 actived ones first
        // );
        setFilteredItems(data);
        const result = await axios.post(
          `${baseUrl}vehicle_model/viewbyid`,
          {
            id: location.state.id,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setValue("model_name", result.data.model_name);
        setValue("image", result.data.image);
        setValue("transmission", result.data.transmission || "");
        setValue("year", result.data.year);
        setValue("brand_id", result.data.brand_id);
        setExistingFile(result.data.image);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [location.state?.id, setValue, refresh]);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${baseUrl}brand/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const filteredBrands = response.data.filter(
          (brand: any) => brand.is_deleted === 0 && brand.is_active === 1
        );

        setBrands(filteredBrands);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };

    fetchBrands();
  }, []);

  const filteredData = filteredItems.filter((item) => {
    return (
      (item.model_name &&
        item.model_name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.brand?.brand_name &&
        item.brand?.brand_name
          .toLowerCase()
          .includes(filterText.toLowerCase())) ||
      (item.image &&
        item.image.toLowerCase().includes(filterText.toLowerCase()))
    );
  });

  const handleEdit = (id: string) => {
    navigate("/edit_model", { state: { id: id } });
  };

  const handleDelete = (id: string) => {
    setDisabledDelete(id);
    setDisableAllDelete(true);
    const confirmToast = () =>
      toast.warn(
        <div>
          <div>Are you sure you want to delete this vehicle model?</div>
          <div className="d-flex justify-content-end mt-2">
            <Button color="danger" onClick={() => confirmDelete(id)}>
              Yes
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setDisabledDelete(null);
                setDisableAllDelete(false);
                toast.dismiss();
              }}
              className="ms-2"
            >
              Cancel
            </Button>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
          draggable: false,
          onClose: () => {
            setDisableAllDelete(false);
            setDisabledDelete(null);
          },
        }
      );

    const confirmDelete = async (id: string) => {
      setDisabledDelete(null);
      setDisableAllDelete(false);
      toast.dismiss();
      try {
        await axios.post(
          `${baseUrl}vehicle_model/delete`,
          { id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success(`Vehicle Models Deleted Successfully`, {
          position: "top-right",
          autoClose: 1000,
          closeOnClick: true,
        });
        setFilteredItems((prevItems) =>
          prevItems.filter((item) => item.id !== id)
        );
      } catch (error) {
        console.error("Error deleting vehicle Models:", error);
        toast.error("An error occurred while deleting the vehicle Models", {
          position: "top-right",
          autoClose: 1000,
          closeOnClick: true,
        });
      }
    };

    confirmToast();
  };

  const toggleEnable = (id: string, currentStatus: number) => {
    setDisabledEnable(id); // reuse this state if needed
    setDisableAllEnable(true);

    const confirmToggle = () => {
      toast.warn(
        <div>
          <div>
            Are you sure you want to{" "}
            <strong>{currentStatus === 1 ? "disable" : "enable"}</strong> this
            model?
          </div>
          <div className="d-flex justify-content-end mt-2">
            <Button
              color={currentStatus === 1 ? "danger" : "success"}
              onClick={() => confirmToggleEnable(id, currentStatus)}
            >
              Yes
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setDisabledEnable(null);
                setDisableAllEnable(false);
                toast.dismiss();
              }}
              className="ms-2"
            >
              Cancel
            </Button>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
          draggable: false,
          onClose: () => {
            setDisabledEnable(null);
            setDisableAllEnable(false);
          },
        }
      );
    };

    const confirmToggleEnable = async (id: string, currentStatus: number) => {
      setDisabledEnable(null);
      setDisableAllEnable(false);
      toast.dismiss();

      try {
        const newStatus = currentStatus === 1 ? 0 : 1;

        await axios.post(
          `${baseUrl}vehicle_model/toggle_active`,
          { id, is_active: newStatus },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        toast.success(
          `Model ${newStatus === 1 ? "enabled" : "disabled"} successfully!`,
          {
            position: "top-right",
            autoClose: 1000,
            closeOnClick: true,
            onClose: () => {
              setRefresh((prev) => prev + 1);
            },
          }
        );
      } catch (error) {
        console.error("Error toggling model:", error);
        toast.error("Error updating enable status", {
          position: "top-right",
          autoClose: 1000,
        });
      }
    };

    confirmToggle();
  };

  // Define columns with actions
  const vehicleModelsTableColumns = [
    {
      name: "Image",
      cell: (row: VehicleModel) => (
        <img
          src={`${mediaUrl}/${row.image}`}
          alt={row.image}
          width={25}
          height={25}
          style={{
            objectFit: "cover",
            borderRadius: "10px",
          }}
        />
      ),
      // sortable: true,
      width: "15%",
    },
    {
      name: "Model Name",
      selector: (row: VehicleModel) => row.model_name,
      sortable: true,
      width: "20%",
    },
    {
      name: "Brand Name",
      selector: (row: VehicleModel) => row.brand?.brand_name,
      sortable: true,
      width: "20%",
    },
    {
      name: "Year",
      selector: (row: VehicleModel) => row.year,
      sortable: true,
      width: "15%",
    },

    {
      name: "Status",
      cell: (row: VehicleModel) => (
        <span
          className={`badge rounded-pill ${
            row.is_active === 1 ? "bg-success" : "bg-danger"
          }`}
        >
          {row.is_active === 1 ? "Enable" : "Disable"}
        </span>
      ),
      // sortable: true,
      width: "15%",
    },
    {
      name: "Actions",
      cell: (row: VehicleModel) => (
        <div className="d-flex justify-content-between">
          <Button
            color={row.is_active ? "success" : "secondary"}
            size="sm"
            onClick={() => toggleEnable(row.id, row.is_active)}
            disabled={disabledEnable === row.id || disableAllEnable}
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            title={row.is_active ? "Disable" : "Enable"}
          >
            <i
              className={`fa ${row.is_active ? "fa-check-circle" : "fa-ban"}`}
            />
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={() => handleEdit(row.id)}
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i className="icon-pencil-alt" />
          </Button>
          <Button
            color="danger"
            size="sm"
            onClick={() => handleDelete(row.id)}
            disabled={disabledDelete === row.id || disableAllDelete}
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i className="icon-trash" />
          </Button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      // button: true,
      width: "15%",
    },
  ];

  // Show a loading spinner while data is being fetched
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#308e87",
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid #308e87",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #dee2e6",
      },
    },
    table: {
      style: {
        border: "1px solid #dee2e6",
        borderRadius: "8px",
      },
    },
  };

  const onSubmit = async (data: FormValues) => {
    setIsButtonDisabled(true);

    try {
      let filename = existingFile;

      // Check if a new file is provided
      if (
        data.image &&
        data.image instanceof FileList &&
        data.image.length > 0
      ) {
        const file = data.image?.[0];
        filename = await uploadFile(file);
        setExistingFile(filename);
      }

      const editdata = {
        model_name: data.model_name,
        brand_id: data.brand_id,
        transmission: data.transmission || "",
        year: data.year,
        image: filename || existingFile,
        id: location.state.id,
      };
      // console.log(editdata, "editdata");
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${baseUrl}vehicle_model/update`,
        editdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        SuccessToast("Data updated successfully", "/view_model");
      } else {
        ErrorToast("Failed to update");
      }
    } catch (err) {
      const axiosError = err as AxiosError;
      const errorResponse = axiosError.response?.data as ErrorResponse;
      const errorMessage =
        errorResponse?.message || "An unexpected error occurred";
      console.error("Error:", errorMessage);
      ErrorToast(errorMessage);
    } finally {
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 2000);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  // Prevent form submission on Enter key press
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <>
      <Breadcrumbs
        pageTitle={EditVehicleModelTitle}
        parent={VehicleModelTitle}
        title={EditVehicleModelTitle}
      />
      <Row>
        <Col xl={4} className="mb-lg-3">
          <Card>
            <CardBody className="custom-input form-validation">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="g-3">
                  <Col xs={12}>
                    <Label htmlFor="brand_id">
                      Brand <small className="text-danger">*</small>
                    </Label>
                    <Controller
                      name="brand_id"
                      control={control}
                      rules={{ required: "Please select a brand" }}
                      render={({ field }) => (
                        <>
                          <Select
                            {...field}
                            id="brand_id"
                            options={brands.map((brand) => ({
                              value: brand.id, // number
                              label: brand.brand_name,
                            }))}
                            placeholder="-- Select Brand --"
                            classNamePrefix="react-select"
                            isSearchable
                            onChange={(selectedOption) =>
                              field.onChange(selectedOption?.value)
                            }
                            value={brands
                              .map((brand) => ({
                                value: brand.id,
                                label: brand.brand_name,
                              }))
                              .find(
                                (option) => option.value === Number(field.value)
                              )} // 👈 fix here
                          />
                          {errors.brand_id && (
                            <div className="text-danger mt-1">
                              {errors.brand_id.message}
                            </div>
                          )}
                        </>
                      )}
                    />
                  </Col>

                  <Col xs={12}>
                    <Label htmlFor="vehicleModel-name">
                      Model Name <small className="text-danger">*</small>
                    </Label>
                    <Controller
                      name="model_name"
                      control={control}
                      rules={{
                        required: "Model name is required",
                      }}
                      render={({ field }) => (
                        <>
                          <Input
                            id="Model-name"
                            type="text"
                            placeholder="Model name"
                            {...field}
                            invalid={!!errors.model_name}
                            style={{
                              color: "var(--input-text-color)",
                              borderColor: errors.model_name ? "red" : "",
                            }}
                            autoComplete="off"
                            onKeyDown={handleKeyDown}
                          />
                          {errors.model_name && (
                            <FormFeedback>
                              {errors.model_name.message}
                            </FormFeedback>
                          )}
                        </>
                      )}
                    />
                  </Col>
                  <Col xs={12}>
                    <Label className="w-100">Transmission</Label>
                    <Controller
                      name="transmission"
                      control={control}
                      render={({ field }) => {
                        const handleChange = (value: string) => {
                          field.onChange(field.value === value ? "" : value);
                        };

                        return (
                          <>
                            <div className="text-body">
                              {["Manual", "Automatic", "Semi-Automatic"].map(
                                (option) => (
                                  <div key={option} className="form-check mb-2">
                                    {" "}
                                    {/* adds spacing between checkboxes */}
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={field.value === option}
                                      onChange={() => handleChange(option)}
                                      id={`transmission-${option}`}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`transmission-${option}`}
                                    >
                                      {option}
                                    </label>
                                  </div>
                                )
                              )}
                            </div>
                          </>
                        );
                      }}
                    />
                  </Col>

                  <Col xs={12}>
                    <Label htmlFor="year" className="w-100">
                      Model Year
                    </Label>
                    <Controller
                      name="year"
                      control={control}
                      // rules={{ required: "Year is required" }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            selected={
                              field.value
                                ? new Date(Number(field.value), 0)
                                : null
                            }
                            onChange={(date: Date) => {
                              field.onChange(date.getFullYear().toString());
                            }}
                            showYearPicker
                            dateFormat="yyyy"
                            maxDate={new Date()} // Prevent selecting future dates
                            className={`form-control`}
                            placeholderText="Select year"
                          />
                        </>
                      )}
                    />
                  </Col>

                  <Col xs={12}>
                    <Label htmlFor="formFile">
                      Image <small className="text-danger">*</small>
                    </Label>
                    <Controller
                      name="image"
                      control={control}
                      rules={{ required: "Image is required" }}
                      render={({ field: { onChange, onBlur, ref } }) => (
                        <>
                          <Input
                            id="formImage"
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) {
                                onChange(e.target.files);
                                // Update the image preview immediately
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  setExistingFile(reader.result as string);
                                };
                                reader.readAsDataURL(file);
                              }
                            }}
                            onBlur={onBlur}
                            innerRef={ref}
                            onKeyDown={handleKeyDown}
                          />
                          {existingFile && (
                            <img
                              src={
                                existingFile.startsWith("data:")
                                  ? existingFile
                                  : `${mediaUrl}/${existingFile}`
                              }
                              alt="Preview"
                              width="70"
                              height="70"
                              style={{ marginTop: "5px", borderRadius: "10px" }}
                            />
                          )}
                        </>
                      )}
                    />
                  </Col>

                  <Col xs={12} className="mt-2">
                    <Btn color="primary" disabled={isButtonDisabled}>
                      {Submit}
                    </Btn>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
        <Col xl={8} className="mb-lg-3">
          <Card>
            <CardBody>
              <div className="mb-3">
                <FilterComponent
                  onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setFilterText(e.target.value)
                  }
                  filterText={filterText}
                />
              </div>
              <div className="table-responsive">
                <DataTable
                  data={filteredData}
                  columns={vehicleModelsTableColumns}
                  pagination
                  highlightOnHover
                  striped
                  customStyles={customStyles}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        toastStyle={{
          userSelect: "none",
        }}
      />
    </>
  );
}

// ////jc
// import React, { useState, useEffect } from "react";
// import { useForm, Controller } from "react-hook-form";
// import {
//   Card,
//   CardBody,
//   Col,
//   Form,
//   Input,
//   Label,
//   Row,
//   FormFeedback,
//   Spinner,
// } from "reactstrap";
// import { Btn } from "../../../AbstractElements";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import axios, { AxiosError } from "axios";
// import "react-datepicker/dist/react-datepicker.css";
// import DatePicker from "react-datepicker";
// import { baseUrl, uploadFile, mediaUrl } from "../../../Utils/FileUpload";
// import {
//   ChooseFile,
//   Submit,
//   ContactNumber,
//   Email,
//   Address,
//   EditVehicleModelTitle,
//   VehicleModelTitle,
// } from "../../../Utils/Constants";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import { useNavigate, useLocation } from "react-router-dom";
// import useCustomToasts from "../../../hooks/useCustomToast";

// interface FormValues {
//   model_name: string;
//   brand_id: string;
//   image: FileList;
//   transmission: string;
//   year: string;
// }
// interface ErrorResponse {
//   message: string;
// }
// export default function EditVehicleModel() {
//   const navigate = useNavigate();
//   const { SuccessToast, ErrorToast } = useCustomToasts(navigate);
//   const [loading, setLoading] = useState(true);
//   const {
//     handleSubmit,
//     setValue,
//     control,
//     formState: { errors },
//   } = useForm<FormValues>({
//     defaultValues: {
//       model_name: "",
//       brand_id: "",
//       image: undefined,
//     },
//   });

//   const [brands, setBrands] = useState<{ id: number; brand_name: string }[]>(
//     []
//   );

//   const token = localStorage.getItem("token");

//   useEffect(() => {
//     const fetchBrands = async () => {
//       try {
//         const response = await axios.get(`${baseUrl}brand/getall`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         const filteredBrands = response.data.filter(
//           (brand: any) => brand.is_deleted === 0 && brand.is_active === 1
//         );

//         setBrands(filteredBrands);
//       } catch (error) {
//         console.error("Error fetching brands:", error);
//       }
//     };

//     fetchBrands();
//   }, []);
//   const [existingFile, setExistingFile] = useState<string>("");
//   const location = useLocation();
//   const [isButtonDisabled, setIsButtonDisabled] = useState(false);

//   useEffect(() => {
//     const fetchStaffsDetails = async () => {
//       try {
//         const token = localStorage.getItem("token");

//         const result = await axios.post(
//           `${baseUrl}vehicle_model/viewbyid`,
//           {
//             id: location.state.id,
//           },
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         // console.log(result.data)
//         // Populate the form with fetched data

//         setValue("model_name", result.data.model_name);
//         setValue("image", result.data.image);
//         setValue("transmission", result.data.transmission || "");
//         setValue("year", result.data.year);
//         setValue("brand_id", result.data.brand_id);
//         setExistingFile(result.data.image);
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching staffs details:", error);
//       }
//     };

//     fetchStaffsDetails();
//   }, [setValue]);

//   const onSubmit = async (data: FormValues) => {
//     setIsButtonDisabled(true);

//     try {
//       let filename = existingFile;

//       // Check if a new file is provided
//       if (
//         data.image &&
//         data.image instanceof FileList &&
//         data.image.length > 0
//       ) {
//         const file = data.image?.[0];
//         filename = await uploadFile(file);
//         setExistingFile(filename);
//       }

//       const editdata = {
//         model_name: data.model_name,
//         brand_id: data.brand_id,
//         transmission: data.transmission || "",
//         year: data.year,
//         image: filename || existingFile,
//         id: location.state.id,
//       };
//       // console.log(editdata, "editdata");
//       const token = localStorage.getItem("token");
//       const response = await axios.post(
//         `${baseUrl}vehicle_model/update`,
//         editdata,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.status === 200) {
//         SuccessToast("Data updated successfully", "/view_model");
//       } else {
//         ErrorToast("Failed to update");
//       }
//     } catch (err) {
//       const axiosError = err as AxiosError;
//       const errorResponse = axiosError.response?.data as ErrorResponse;
//       const errorMessage =
//         errorResponse?.message || "An unexpected error occurred";
//       console.error("Error:", errorMessage);
//       ErrorToast(errorMessage);
//     } finally {
//       setTimeout(() => {
//         setIsButtonDisabled(false);
//       }, 2000);
//     }
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <Spinner color="primary" />
//       </div>
//     );
//   }

//   // Prevent form submission on Enter key press
//   const handleKeyDown = (e: React.KeyboardEvent) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//     }
//   };

//   return (
//     <>
//       <Breadcrumbs
//         pageTitle={EditVehicleModelTitle}
//         parent={VehicleModelTitle}
//         title={EditVehicleModelTitle}
//       />
//       <Col xl={12} className="mb-lg-3">
//         <Card>
//           <CardBody className="custom-input form-validation">
//             <Form onSubmit={handleSubmit(onSubmit)}>
//               <Row className="g-3">
//                 <Col xs={12}>
//                   <Label htmlFor="vehicleModel-name">VehicleModel Name</Label>
//                   <Controller
//                     name="model_name"
//                     control={control}
//                     rules={{
//                       required: "Model name is required",
//                       pattern: {
//                         value: /^[A-Za-z0-9\s.'-]{2,50}$/,
//                         message:
//                           "Invalid Model name. Only letters,dots, numbers, spaces, hyphens (-), and apostrophes (') are allowed.",
//                       },
//                       validate: (value) => {
//                         // Ensure it's not all numbers or just special characters

//                         if (/^\d+$/.test(value)) {
//                           return "Model name cannot be all numbers.";
//                         }
//                         if (/^[^A-Za-z]+$/.test(value)) {
//                           return "Model name must include letters.";
//                         }
//                         return true;
//                       },
//                     }}
//                     render={({ field }) => (
//                       <>
//                         <Input
//                           id="Model-name"
//                           type="text"
//                           placeholder="Model name"
//                           {...field}
//                           invalid={!!errors.model_name}
//                           style={{
//                             color: "var(--input-text-color)",
//                             borderColor: errors.model_name ? "red" : "",
//                           }}
//                           autoComplete="off"
//                           onKeyDown={handleKeyDown}
//                         />
//                         {errors.model_name && (
//                           <FormFeedback>
//                             {errors.model_name.message}
//                           </FormFeedback>
//                         )}
//                       </>
//                     )}
//                   />
//                 </Col>

//                 <Col xs={12}>
//                   <Label htmlFor="brand_id">Brand</Label>
//                   <Controller
//                     name="brand_id"
//                     control={control}
//                     rules={{ required: "Please select a brand" }}
//                     render={({ field }) => (
//                       <>
//                         <Input
//                           type="select"
//                           {...field}
//                           id="brand_id"
//                           invalid={!!errors.brand_id}
//                         >
//                           <option value="">-- Select Brand --</option>
//                           {brands.map((brand) => (
//                             <option key={brand.id} value={brand.id}>
//                               {brand.brand_name}
//                             </option>
//                           ))}
//                         </Input>
//                         {errors.brand_id && (
//                           <FormFeedback>{errors.brand_id.message}</FormFeedback>
//                         )}
//                       </>
//                     )}
//                   />
//                 </Col>
//                 <Col xs={12}>
//                   <Label className="w-100">Transmission</Label>
//                   <Controller
//                     name="transmission"
//                     control={control}
//                     render={({ field }) => {
//                       const handleChange = (value: string) => {
//                         field.onChange(field.value === value ? "" : value);
//                       };

//                       return (
//                         <>
//                           <div className="d-flex gap-4 text-body">
//                             {["Manual", "Automatic", "Both"].map((option) => (
//                               <div key={option} className="form-check">
//                                 <input
//                                   className="form-check-input"
//                                   type="checkbox"
//                                   checked={field.value === option}
//                                   onChange={() => handleChange(option)}
//                                   id={`transmission-${option}`}
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor={`transmission-${option}`}
//                                 >
//                                   {option}
//                                 </label>
//                               </div>
//                             ))}
//                           </div>
//                         </>
//                       );
//                     }}
//                   />
//                 </Col>

//                 <Col xs={12}>
//                   <Label htmlFor="year" className="w-100">
//                     Year
//                   </Label>
//                   <Controller
//                     name="year"
//                     control={control}
//                     rules={{ required: "Year is required" }}
//                     render={({ field }) => (
//                       <>
//                         <DatePicker
//                           selected={
//                             field.value
//                               ? new Date(Number(field.value), 0)
//                               : null
//                           }
//                           onChange={(date: Date) => {
//                             field.onChange(date.getFullYear().toString());
//                           }}
//                           showYearPicker
//                           dateFormat="yyyy"
//                           className={`form-control ${
//                             errors.year ? "is-invalid" : ""
//                           }`}
//                           placeholderText="Select year"
//                         />
//                         {errors.year && (
//                           <div className="invalid-feedback d-block">
//                             {errors.year.message}
//                           </div>
//                         )}
//                       </>
//                     )}
//                   />
//                 </Col>

//                 <Col xs={12}>
//                   <Label htmlFor="formFile">Image</Label>
//                   <Controller
//                     name="image"
//                     control={control}
//                     rules={{ required: "Image is required" }}
//                     render={({ field: { onChange, onBlur, ref } }) => (
//                       <>
//                         <Input
//                           id="formImage"
//                           type="file"
//                           accept="image/*"
//                           onChange={(e) => {
//                             const file = e.target.files?.[0];
//                             if (file) {
//                               onChange(e.target.files);
//                               // Update the image preview immediately
//                               const reader = new FileReader();
//                               reader.onloadend = () => {
//                                 setExistingFile(reader.result as string);
//                               };
//                               reader.readAsDataURL(file);
//                             }
//                           }}
//                           onBlur={onBlur}
//                           innerRef={ref}
//                           onKeyDown={handleKeyDown}
//                         />
//                         {existingFile && (
//                           <img
//                             src={
//                               existingFile.startsWith("data:")
//                                 ? existingFile
//                                 : `${mediaUrl}/${existingFile}`
//                             }
//                             alt="Preview"
//                             width="70"
//                             height="70"
//                             style={{ marginTop: "5px", borderRadius: "10px" }}
//                           />
//                         )}
//                       </>
//                     )}
//                   />
//                 </Col>

//                 <Col xs={12} className="mt-2">
//                   <Btn color="primary" disabled={isButtonDisabled}>
//                     {Submit}
//                   </Btn>
//                 </Col>
//               </Row>
//             </Form>
//           </CardBody>
//         </Card>
//       </Col>
//       <ToastContainer
//         toastStyle={{
//           userSelect: "none",
//         }}
//       />
//     </>
//   );
// }
